<template>
  <b-container fluid>
      <b-row>
        <b-col lg="12" sm="12" class="text-center mb-4">
            <h5 class='complain-title'>{{ $t('globalTrans.payment') }}</h5>
        </b-col>
        <b-col lg="12" sm="12">
            <b-overlay :show="loading">
            <template>
                <b-row v-if="is_payment">
                    <b-col class="text-dark">
                        <b-button @click="is_payment = false" class="btn btn-sm btn-warning"><span><i class="ri-arrow-left-line"></i>Back</span></b-button>
                    </b-col>
                    <b-col lg="12" sm="12">
                        <div class="text-center">
                            <b-form-radio-group
                            v-model="payment_type_id"
                            :options="paymentTypeList"
                            ></b-form-radio-group>
                        </div>
                        <keep-alive>
                            <component v-bind:is="comp" :payment="payment" @clicked="onClickChild"></component>
                        </keep-alive>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col lg="6" sm="6" offset-lg="3">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            :label="$t('externalUser.select_receive_order')"
                            label-for="receive_id"
                            >
                        <v-select
                            v-model="receive_id"
                            multiple
                            :options="receiveList"
                            label="text"
                            :reduce="item => item.value"
                        >
                            <template v-slot:option="option">
                            <div class="row">
                                <div class="col-md-6">
                                <span class="fa fa-list"></span>
                                {{ option.text }}
                                </div>
                                <div class="col-md-6 text-right">
                                ({{ option.receive_date }})
                                </div>
                            </div>
                            </template>
                        </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-row v-if="showPayment">
                            <b-col lg="12" v-for="(itm, indx) in singleOrder" :key="indx"  sm="12">
                                <span style="font-size: 20px;font-weight:bold" class="text-dark"><u>{{ $t('externalUser.receive_list') }}</u></span>
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                        <!-- <b-th>{{ $t('retailerManagement.quantity') }}</b-th> -->
                                        <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                        <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                                    </b-tr>
                                    <b-tr v-for="(item, index) in itm.details" :key="index">
                                        <b-td>{{ $n(index + 1) }}</b-td>
                                        <b-td>{{ productNameById(item.product_id) }}</b-td>
                                        <!-- <b-td>{{ $n(item.quantity) }}</b-td> -->
                                        <b-td>{{ $n(item.receive_quantity) }}</b-td>
                                        <b-td>{{ $n(item.unit_price) }}</b-td>
                                        <b-td>{{ $n(item.total_price) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="4">
                                            <span style="margin-left:85%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(itm.total_amount) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td colspan="4">
                                            <span style="margin-left:85%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ $n(itm.due_amount) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </b-col>
                            <div class="col-md-12">
                                <b-table-simple striped bordered small>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:85%">{{ $t('externalUser.grand_toal') }}</span>
                                        </b-td>
                                        <b-td>{{ getAllGrandTotal(singleOrder) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>
                                            <span style="margin-left:85%">{{ $t('externalUser.total_due') }}</span>
                                        </b-td>
                                        <b-td>{{ getDueGrandTotal(singleOrder) }}</b-td>
                                    </b-tr>
                                </b-table-simple>
                            </div>
                            <div class="col-md-12">
                                <div class="text-right">
                                    <b-button @click="setPayment(singleOrder, 0)" class="btn btn-success btn-sm" style="width:90px">{{ $t('externalUser.full_pay') }}</b-button>
                                    <b-button v-if="singleOrder.length === 1" @click="setPayment(singleOrder, 1)" class="btn btn-success btn-sm ml-2"  style="width:90px">{{ $t('externalUser.pertial_pay') }}</b-button>
                                </div>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
                <div class="row mt-2">
                    <div class="col-md-12 text-right">
                        <hr>
                        <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-payment')">{{ $t('globalTrans.cancel') }}</b-button>
                    </div>
                </div>
            </template>
            </b-overlay>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { deliveryRecPayList } from '../../../api/routes'
import PaymentEkpay from './PaymentEkpay'
import PaymentVoucher from './PaymentVoucher'

export default {
  components: {
    PaymentVoucher,
    PaymentEkpay
  },
  data () {
    return {
      is_payment: false,
      payment_type_id: 1,
      receive_id: [],
      comp: 'PaymentEkpay',
      dealerId: 0,
      receiveList: [],
      loading: false,
      singleOrder: [],
      showPayment: false,
      payment: {
          is_partial: '',
          paymentList: ''
      }
    }
  },
  created () {
    this.getOrderList()
  },
  computed: {
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    paymentTypeList () {
        return this.$store.state.ExternalUser.commonObj.paymentTypeList.filter(item => item.value !== 3)
    }
  },
  watch: {
    payment_type_id: function (n, o) {
        if (n !== o) {
          if (n === 2) {
              this.comp = 'PaymentVoucher'
          } else {
              this.comp = 'PaymentEkpay'
          }
        }
    },
    receive_id: function (n, o) {
        if (n !== o) {
         this.getOrderDetails(n)
        }
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    onClickChild () {
      this.$bvModal.hide('modal-payment')
    },
    getOrderList () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, deliveryRecPayList).then(response => {
            if (response.success) {
                const tmpData = response.data.map(item => {
                    return Object.assign(item, { value: item.id, text: item.receive_id, title: item.receive_id })
                })
                this.receiveList = tmpData
                this.loading = false
            }
        })
    },
    getOrderDetails (Ids) {
        if (Ids.length) {
            this.singleOrder = []
            Ids.map(Id => {
                this.showPayment = true
                const tmpData = this.receiveList.find(item => item.id === parseInt(Id))
                const tmp = JSON.parse(JSON.stringify(tmpData))
                this.singleOrder.push(Object.assign(tmp, { total_price: this.getGrandTotal(tmp) }))
            })
        } else {
            this.singleOrder = []
            this.showPayment = false
        }
    },
    getGrandTotal (tmp) {
      const result = tmp.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
      const total = parseFloat(result)
      return total
    },
    getAllGrandTotal (tmp) {
      const result = tmp.reduce((total, item) => total + parseFloat(item.total_amount), 0)
      const total = parseFloat(result)
      return total
    },
    getDueGrandTotal (tmp) {
      const result = tmp.reduce((total, item) => total + parseFloat(item.due_amount), 0)
      const total = parseFloat(result)
      return total
    },
    productNameById (id) {
        const product = this.$store.state.ExternalUser.productionCommonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    setPayment (item, isPertial) {
        this.is_payment = true
        this.payment.is_partial = isPertial
        this.payment.paymentList = item
    },
    getPaymentStatus (status) {
        const Status = this.$store.state.ExternalUser.commonObj.paymentStatusList.find(item => item.value === status)
        if (this.$i18n.locale === 'bn') {
            return Status.text_bn
        } else {
            return Status.text_en
        }
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
